import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";
import Flexbox from "flexbox-react";
import ActivityPlayerShowMode from "./ActivityPlayerShowMode";
import PlayerPaths from "../../constants/paths/playerPaths";

// import { AmbifiLoader } from "../shared/loader"

class PlayerShowMode extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	render() {
		let activity;

		const additionalProps = {};

		if (this.props.activity && this.props.activity.showModeKey) {
			additionalProps.key = this.props.activity.showModeKey;
		}

		if (_.isEmpty(this.props.activity)) {
			activity = <div></div>;
		} else {
			activity = <ActivityPlayerShowMode editable={true} activity={this.props.activity} /*activityIdentityId={this.props.user.identityId}*/ activityIdentityId="No User" showAcceptDefaultButton={true} showMode={this.props.activity.startInShowMode} {...additionalProps} />;
		}

		let page = <Flexbox flexDirection="column" style={{ width: "100%", height: "100%" }}>
			{activity}
			{/* <AmbifiLoader fullPage show={this.props.player.showSpinner} /> */}
		</Flexbox>;

		return page;
	}
}

PlayerShowMode.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	user: ["user"],
	player: PlayerPaths.ROOT,
	activity: PlayerPaths.ACTIVITY,
	navStack: PlayerPaths.NAV_STACK
}, PlayerShowMode);